export default {
  setPatient(state, patient) {
    state.patient = patient
  },
  setProvider(state, provider) {
    state.provider = provider
  },
  setUploadInfo(state, uploadInfo) {
    state.uploadInfo = uploadInfo
  },
  setUploadURL(state, uploadURL) {
    state.uploadURL = uploadURL
  },
  setPatientUploadURL(state, uploadPatientURL) {
    state.uploadPatientURL = uploadPatientURL
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/upload/mutations.js